import { createSSRApp } from 'vue'
import App from './App.vue'
import {createStore} from './store'
import  {createRouter} from './router/index.js'
import ApiSource from './api/ApiSource.js'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import 'swiper/css';
import 'swiper/css/autoplay';
import 'floating-vue/dist/style.css'
import VueLazyload from "vue-lazyload";
import ToastPlugin from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';
import VueSocialSharing from 'vue-social-sharing'
import momentPlugin from './plugins/momentPlugin.js'
import KpIcon from './components/Icon.vue'
import AlertBox from '@/components/element/AlertBox.vue'
import ConfirmPlugin from './plugins/confirmModal.js'
import MessageModalPlugin from './plugins/messageModal.js'
import FloatingVue from 'floating-vue'

dayjs.locale('ru')

if (typeof crypto === 'undefined' && typeof window !== 'undefined') {
  window.crypto = {};
}
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  crypto.randomUUID = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

String.prototype.firstLetterToUppercase = function() {
    return this[0].toUpperCase() + this.slice(1);
}
const isSSR = typeof window === 'undefined';

export default function buildApp() {
    const app = createSSRApp(App)
    const store = createStore();
    const router = createRouter();
    app.component('KpIcon', KpIcon);
    app.component('AlertBox', AlertBox)
    app.use(store).use(router).use(ApiSource).use(ToastPlugin).use(VueSocialSharing).use(momentPlugin);
    router.$store = store;
    store.$API =  app.config.globalProperties.$API
    store.$toast = app.config.globalProperties.$toast
    store.$router =  app.config.globalProperties.$router

    app.config.globalProperties.$dayjs = dayjs

    app.use(ConfirmPlugin)
    app.use(MessageModalPlugin)
    app.use(FloatingVue, {
        distance: 8
    })

    app.use(VueLazyload, {
        preLoad: 1.3,
        error: '/assets/img/card_placeholder.png',
        loading: '/assets/img/card_placeholder.png',
        attempt: 1
    })

    return { app, router, store };
}
